import type { Story } from '@/mocks/featuredStories';

const CAT_ICON: Record<Story['category'], string> = {
  综艺: 'ri-movie-2-line',
  影视: 'ri-film-line',
  明星: 'ri-star-smile-line',
  行业: 'ri-line-chart-line',
};

interface Props {
  story: Story;
  className?: string;
}

export default function StoryCover({ story, className = '' }: Props) {
  if (story.cover) {
    return (
      <img src={story.cover} alt={story.title} className={`h-full w-full object-cover ${className}`} />
    );
  }
  return (
    <div
      className={`flex h-full w-full items-center justify-center bg-gradient-to-br from-primary-600 via-primary-500 to-accent-600 ${className}`}
    >
      <div className="flex flex-col items-center px-4 text-center">
        <i className={`${CAT_ICON[story.category]} text-4xl text-background-50/90`} />
        <span className="mt-2 max-w-full truncate px-2 font-heading text-sm font-bold tracking-wide text-background-50">
          {story.category}·编辑部号外
        </span>
      </div>
    </div>
  );
}